import {GET_TABLE_DATA_INVENTORY_EXPENSE} from '../../../../constants/ActionTypes'
import { zeroPad } from '../../../../util/DaFrameword';
const InitialState={
    TableData:[]
}
function InventoryExpense (state=InitialState, action){
    switch (action.type) {
        case GET_TABLE_DATA_INVENTORY_EXPENSE:

            let NewData=action.payload.map((data, index)=>(
                ({
                ...data,
                code:zeroPad(data.code,2),
                description:data.description,     
                account:data?.catalogAccount?.account,
                name:data?.catalogAccount?.display
            })));

            return {

                TableData:NewData
            };
        default:
          return state;
    }
}

export default InventoryExpense;